import { render } from "./Approvem.vue?vue&type=template&id=5b5af9f8&scoped=true&ts=true"
import script from "./Approvem.vue?vue&type=script&lang=ts"
export * from "./Approvem.vue?vue&type=script&lang=ts"

import "./Approvem.vue?vue&type=style&index=0&id=5b5af9f8&lang=less&scoped=true"

import exportComponent from "E:\\project\\ale\\建大车辆入校预约\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5af9f8"]])

export default __exports__